import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {deleteReport, getReports, messageReset, editSaveReport, clearReports, sendReport} from "../store/reports";
import Button from "@mui/material/Button";
import Header from "../blocks/header";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Dashboard from "../blocks/dashboard";
import Copyright from "../blocks/copyright";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import DeleteModal from "../blocks/deleteModal";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import {FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Pagination, Select, Tab, Tabs} from "@mui/material";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import {TabContext, TabList} from "@mui/lab";
import TabPanel from "@mui/lab/TabPanel";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const label = {inputProps: {'aria-label': 'Checkbox'}};
const PAGE_SIZE = 20
const STATUS_MAP = {one: 1, two: 2, three: 3, four: 4}

function Reports(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const regionId = params.id || false

    const [tab, setTab] = useState('one')
    const [adminRegionId, setAdminRegionId] = useState('')
    const [open, setOpen] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [year, setYear] = useState(new Date().getFullYear().toString())
    const [month, setMonth] = useState(1)
    const [search, setSearch] = useState('')
    const [fileIds, setFileIds] = useState([])
    const [page, setPage] = useState(1)

    function fetchData(pg, yr, mn, st, rid) {
        const _page   = pg  !== undefined ? pg  : page
        const _year   = yr  !== undefined ? yr  : year
        const _month  = mn  !== undefined ? mn  : month
        const _status = st  !== undefined ? st  : STATUS_MAP[tab]
        const _rid    = rid !== undefined ? rid : (regionId || adminRegionId || '')
        const useYear = typeof _year === 'object'
            ? (_year?.$y || new Date(_year).getFullYear()).toString()
            : _year
        props.getReports(_page, PAGE_SIZE, useYear, _month, _rid, '', _status, '')
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid); setPage(1)
        fetchData(1, year, month, STATUS_MAP[tab], rid)
    }

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token !== 'undefined') {
            props.getAllVerifyResponse({"token": JSON.parse(token)})
        }
        if (!year || year == 1970) setYear(new Date().getFullYear().toString())
        fetchData(1)
    }, [])

    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        setFileIds([]); setPage(1)
        props.clearReports()
        fetchData(1, year, month, STATUS_MAP[tab])
    }, [tab])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            setOpenItem(false); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function ToFilter(e) {
        e.preventDefault(); setPage(1)
        fetchData(1, year, month, STATUS_MAP[tab])
    }

    function saveFile() {
        if (!year || year == 1970) setYear(new Date().getFullYear().toString())
        if (fileIds.length > 0 || tab !== 'one') {
            const bodyFormData = new FormData()
            if (fileIds.length > 0) fileIds.forEach(id => bodyFormData.append("id_list", id))
            if (regionId) bodyFormData.append("region_id", regionId)
            if (tab !== 'one') {
                const tabId = {two:"2", three:"3", four:"4"}[tab] || "0"
                bodyFormData.append("table_id", tabId)
                bodyFormData.append("month", month.toString())
                bodyFormData.append("year", typeof year !== "string" || year == 1970
                    ? new Date(year).getFullYear().toString()
                    : year.toString())
            }
            axios({url:'https://ishlabchiqarish.uzkoj.uz/api/get-excel/', method:'POST', data:bodyFormData, responseType:'blob'})
                .then(response => {
                    const href = URL.createObjectURL(response.data)
                    const link = document.createElement('a')
                    link.href = href; link.setAttribute('download', `hisobot_${Date.now()}.xlsx`)
                    document.body.appendChild(link); link.click()
                    document.body.removeChild(link); URL.revokeObjectURL(href)
                })
        } else {
            axios({url:'https://ishlabchiqarish.uzkoj.uz/api/get-excel/', method:'GET', responseType:'blob'})
                .then(response => {
                    const href = URL.createObjectURL(response.data)
                    const link = document.createElement('a')
                    link.href = href; link.setAttribute('download', `hisobot_${Date.now()}.xlsx`)
                    document.body.appendChild(link); link.click()
                    document.body.removeChild(link); URL.revokeObjectURL(href)
                })
        }
    }

    function allowResubmit(item) {
        axios({
            url: `https://ishlabchiqarish.uzkoj.uz/api/reports/${item.id}/allow-resubmit/`,
            method: 'POST',
            headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('token'))}`}
        }).then(() => {
            toast.success(t('resubmit_allowed'), {theme: 'colored'}); fetchData()
        }).catch(() => toast.error(t('save_error'), {theme: 'colored'}))
    }

    function monthSelect(val) {
        const map = {1: t('quarter'), 2: t('semi_annual'), 3: t('nine_month'), 4: t('yearly')}
        return map[val] || ''
    }

    function statusSelect(val) {
        const map = {1: t('no_send'), 2: t('review'), 3: t('canceled'), 4: t('accepted')}
        return map[val] || ''
    }

    function fileId(value) {
        setFileIds(prev => prev.includes(value) ? prev.filter(id => id !== value) : [...prev, value])
    }

    const reports = props.reports || []

    function ReportTable({statusFilter}) {
        if (!reports.length) return <div className={'no-infos'}>{t('no_info')}</div>
        return (
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th>#</th>
                    {is_main && <th>{t('title_company')}</th>}
                    {is_main && <th>{t('year_plan_currently')}</th>}
                    {is_main && <th>{t('responsible_person')}</th>}
                    <th>{t('type')}</th>
                    <th>{t('report_year')}</th>
                    <th>{t('report_month')}</th>
                    <th>{t('status')}</th>
                    {is_main && <th>{t('report_sent_time')}</th>}
                    <th/>
                </tr>
                </thead>
                <tbody>
                {reports.map((item, index) => (
                    <tr key={item.id}>
                        {is_main
                            ? <th><Checkbox checked={fileIds.includes(item.id)} onChange={() => fileId(item.id)} color="primary"/></th>
                            : <th>{index + 1}</th>}
                        {is_main && <td>{item.user?.user_name}</td>}
                        {is_main && <td>{item.year_plan_currently}</td>}
                        {is_main && <td>{item.responsible_person || '-'}</td>}
                        <td>{item.type === 1 ? t('type_report') : t('type_reply_report')}</td>
                        <td>{item.year}</td>
                        <td>{monthSelect(item.month)}</td>
                        <td>
                            <span className={'status' + item.status}>{statusSelect(item.status)}</span>
                            {item.is_send && <><br/>{item.true_time ? t('true_time') : t('notrue_time')}</>}
                        </td>
                        {is_main && <td style={{whiteSpace:'nowrap'}}>{item.created_time ? new Date(item.created_time).toLocaleString('ru-RU') : '-'}</td>}
                        <td>
                            <Button variant="contained" color="primary" endIcon={<VisibilityIcon/>}
                                    onClick={() => navigate('/view-report/' + item.id)}/>
                            {!item.is_send && <>
                                <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                        onClick={() => navigate('/edit-report/' + item.id)}/>
                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                        onClick={() => { setOpenItem(item); setOpen(true) }}/>
                            </>}
                            {is_main && item.is_send && <>
                                {item.status === 2 && <>
                                    <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                            onClick={() => navigate('/edit-report/' + item.id)}/>
                                    <Button variant="contained" color="warning" endIcon={<LockOpenIcon/>}
                                            title={t('allow_resubmit')} onClick={() => allowResubmit(item)}
                                            style={{minWidth:'auto'}}/>
                                </>}
                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                        onClick={() => { setOpenItem(item); setOpen(true) }}/>
                            </>}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        )
    }

    return <div>
        <div className={'page'}>
            {open ? <DeleteModal setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow:1, height:'100vh', overflow:'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                        {t('back')}
                    </Button>
                    <div className={'worker-page'}>
                        <div className={'header-page'}>
                            <h2 className={'page-title'}>{t('reports')}</h2>
                            {!is_main && (
                                <Button variant="contained" endIcon={<AddIcon/>} onClick={() => navigate('/add-report/')}>
                                    {t('add_report')}
                                </Button>
                            )}
                        </div>
                        <div className={'filter-block'}>
                            <form onSubmit={ToFilter}>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                    <span>{t('report_year')}:</span>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            minDate={new Date("2022-01-01")}
                                            views={['year']}
                                            label={t('report_year')}
                                            value={year}
                                            onChange={(newValue) => {
                                                const yr = newValue?.$y || new Date(newValue).getFullYear()
                                                setYear(yr.toString())
                                            }}
                                            renderInput={(params) => <TextField {...params}/>}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div style={{display:'flex', flexDirection:'column'}}>
                                    <span>{t('report_month')}:</span>
                                    <Box sx={{minWidth:200}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="month-label">{t('report_month')}</InputLabel>
                                            <Select labelId="month-label" value={month} label={t('report_month')}
                                                    onChange={(e) => setMonth(e.target.value)}>
                                                <MenuItem value={1}>{t('quarter')}</MenuItem>
                                                <MenuItem value={2}>{t('semi_annual')}</MenuItem>
                                                <MenuItem value={3}>{t('nine_month')}</MenuItem>
                                                <MenuItem value={4}>{t('yearly')}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </div>
                                <Button type={'submit'} className={'filter-btn'} variant="contained"
                                        color="primary">{t('filter')}</Button>
                            </form>
                            {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}
                            {is_main && !regionId && (
                                <div style={{marginTop:'10px'}}>
                                    <FormControl variant="outlined" style={{minWidth:300}}>
                                        <InputLabel htmlFor="search-company">{t('search_company')}</InputLabel>
                                        <OutlinedInput
                                            id="search-company" value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                            label={t('search_company')}/>
                                    </FormControl>
                                </div>
                            )}
                        </div>

                        <TabContext value={tab}>
                            <Box sx={{borderBottom:1, borderColor:'divider'}}>
                                <TabList onChange={(e, val) => setTab(val)}>
                                    <Tab value="one" label={t('no_send')}/>
                                    <Tab value="two" label={t('review')}/>
                                    <Tab value="three" label={t('canceled')}/>
                                    <Tab value="four" label={t('accepted')}/>
                                </TabList>
                            </Box>
                            {['one','two','three','four'].map((tabVal, i) => (
                                <TabPanel key={tabVal} value={tabVal}>
                                    <ReportTable statusFilter={i+1}/>
                                    {is_main && (
                                        <Button onClick={saveFile} variant="contained" color="primary" style={{marginTop:'8px'}}>
                                            {t('download_reports')}
                                        </Button>
                                    )}
                                </TabPanel>
                            ))}
                        </TabContext>

                        {props.total_pages > 1 && (
                            <div style={{display:'flex', justifyContent:'center', padding:'20px 0'}}>
                                <Pagination count={props.total_pages} page={page}
                                            onChange={handlePageChange} color="primary" shape="rounded"/>
                            </div>
                        )}
                    </div>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.report, {
    getReports, deleteReport, editSaveReport, getAllVerifyResponse, messageReset, clearReports, sendReport
})(Reports)
